import { render, staticRenderFns } from "./ListExchange.vue?vue&type=template&id=a3571998&scoped=true"
import script from "./ListExchange.vue?vue&type=script&lang=js"
export * from "./ListExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3571998",
  null
  
)

export default component.exports